import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import type { ComponentProps } from 'react';
import { Button } from '../../button/Button';

/**
 * DropdownMenu用の操作メニュートリガーボタン（EllipsisVerticalIcon アイコン）
 *
 * DropdownMenuTrigger(asChild) が ref やイベントハンドラを children にマージするため、
 * rest props を Button に透過させる必要がある
 */
type DropdownMenuIconButtonProps = Omit<ComponentProps<typeof Button>, 'children' | 'size'> & {
  'aria-label': string;
};

export const DropdownMenuIconButton = ({
  variant = 'non-outline',
  ...props
}: DropdownMenuIconButtonProps) => (
  <Button variant={variant} size="icon" {...props}>
    <EllipsisVerticalIcon className="h-4 w-4" />
  </Button>
);
